"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Factory_1 = require("./Factory");

var DividendDistribution_1 = require("../DividendDistribution");

var types_1 = require("../../types");

var SecurityToken_1 = require("../SecurityToken");

var PolymathError_1 = require("../../PolymathError");

var Checkpoint_1 = require("../Checkpoint");
/**
 * @hidden
 * Generates Dividend Distribution entities
 */


var DividendDistributionFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(DividendDistributionFactory, _Factory_1$Factory);

  // eslint-disable-next-line require-jsdoc
  function DividendDistributionFactory(context) {
    var _this;

    _classCallCheck(this, DividendDistributionFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DividendDistributionFactory).call(this, DividendDistribution_1.DividendDistribution, context));

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _DividendDistribution, index, securityTokenId, _SecurityToken_1$Secu, symbol, contractWrappers, _ref, _ref2, dividendsModule, _a, checkpointIndex, dividend, checkpointId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _DividendDistribution = DividendDistribution_1.DividendDistribution.unserialize(uid), index = _DividendDistribution.index, securityTokenId = _DividendDistribution.securityTokenId;
                _SecurityToken_1$Secu = SecurityToken_1.SecurityToken.unserialize(securityTokenId), symbol = _SecurityToken_1$Secu.symbol;
                contractWrappers = this.context.contractWrappers;
                _context.next = 5;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 5:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 1);
                dividendsModule = _ref2[0];

                if (dividendsModule) {
                  _context.next = 10;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The Dividends Feature hasn't been enabled"
                });

              case 10:
                _context.next = 12;
                return contractWrappers.getDividend({
                  dividendIndex: index,
                  dividendsModule: dividendsModule
                });

              case 12:
                _a = _context.sent;
                checkpointIndex = _a.checkpointId;
                dividend = __rest(_a, ["checkpointId"]);
                checkpointId = Checkpoint_1.Checkpoint.generateId({
                  securityTokenId: securityTokenId,
                  index: checkpointIndex
                });
                return _context.abrupt("return", Object.assign({}, dividend, {
                  checkpointId: checkpointId,
                  securityTokenId: securityTokenId,
                  securityTokenSymbol: symbol
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    return _this;
  }

  return DividendDistributionFactory;
}(Factory_1.Factory);

exports.DividendDistributionFactory = DividendDistributionFactory;